<template>
    <div class="upload-constraints-hint">
        <div v-if="extensions?.length" class="upload-constraints-hint__item">
            Supported file types: {{ formattedExtensions }}.
        </div>
        <div v-if="maxSizeDisplay" class="upload-constraints-hint__item">Maximum file size: {{ maxSizeDisplay }}.</div>
    </div>
</template>

<script>
export default {
    name: 'UploadConstraintsHint',

    props: {
        /**
         * Array of file extensions (e.g., ['.mp4', '.mov'])
         */
        extensions: {
            type: Array,
            default: () => [],
        },

        /**
         * Human-readable max file size string (e.g., '500 MB')
         */
        maxSizeDisplay: {
            type: String,
            default: '',
        },
    },

    computed: {
        formattedExtensions() {
            if (!this.extensions?.length) {
                return '';
            }

            return this.extensions.join(', ');
        },
    },
};
</script>

<style lang="scss" scoped>
.upload-constraints-hint {
    color: #7a7a7a;

    &__item {
        display: block;

        &:not(:last-child) {
            margin-bottom: 0.25rem;
        }
    }
}
</style>
